<template>
    <div class="chatbot-fixed-old__header">
        <div class="chatbot-fixed-old__header-start">
            <img src="@/assets/images/chatbot/logo.svg" />
            <span class="chatbot-fixed-old__header-title">—</span>
            <span class="chatbot-fixed-old__header-title">{{ $t('Chatbot.title') }}</span>
        </div>
        <div class="chatbot-fixed-old__header-end" v-if="isChatDataLoaded">
            <div
                v-if="!showIntroPanel"
                @click="confirmNewChatSession"
                class="chatbot-fixed-old__clear-messages icon-bin"
                v-tooltip="{ content: $t('Chatbot.tooltip_clear'), html: true }"
            >
            </div>
            <div
                class="chatbot-fixed-old__close-button icon-minimize"
                @click="closeChatbot"
                v-tooltip="{ content: $t('Chatbot.tooltip_close'), html: true }"
            >
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ChatBotHeader',
        props: {
            isChatDataLoaded: {
                type: Boolean,
                default: false
            },
            showIntroPanel: Boolean
        },
        methods: {
            confirmNewChatSession () {
                this.$emit('confirm-new-chat-session')
            },
            closeChatbot () {
                this.$emit('close-chatbot')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .chatbot-fixed-old {
        &__header-title {
            font-size: 1.6rem;
            font-family: Quicksand-Bold, sans-serif;

            [class*="mobile"] & {
                font-size: 1.4rem;
            }
        }

        &__beta-label {
            font-size: 1.2rem;
        }

        &__tooltip {
            background: $tundora;
            text-align: center;
            color: $white;
            font-family: Nunito-Regular, sans-serif;
        }

        .icon-spinner {
            padding: 20px;
        }

        .header-end {
            [class*="mobile"] & {
                gap: 0;
            }
        }
    }
</style>
